export default {
  CREATING: 'ADMIN_VIEW_VARIABLES_CREATOR_CREATING',
  CREATED: 'ADMIN_VIEW_VARIABLES_CREATOR_CREATED',
};
